import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { DropdownTrigger } from '@atlassian/entry-points/dropdown-trigger';

import { errorDropdownEntryPoint } from '../fixtures/constellation/error-dropdown-entry-point';
import { RelayWrapper } from '../utils/wrapper';

function CustomError(): React.JSX.Element {
	return (
		<Box padding="space.200">
			<Stack space="space.100" role="alert">
				<Text weight="bold">Page actions are unavailable</Text>
				<Text>This example failed on purpose. Dismiss the menu to continue.</Text>
			</Stack>
		</Box>
	);
}

export default function DropdownTriggerCustomError(): React.JSX.Element {
	return (
		<RelayWrapper>
			<DropdownTrigger
				entryPoint={errorDropdownEntryPoint}
				trigger="Show custom error"
				menuLabel="Page actions"
				loadingText="Loading page actions"
				errorFallback={CustomError}
				shouldRenderToParent
			/>
		</RelayWrapper>
	);
}
